import { render, staticRenderFns } from "./SidebarAddGendec.vue?vue&type=template&id=1e4859d6&"
import script from "./SidebarAddGendec.vue?vue&type=script&lang=js&"
export * from "./SidebarAddGendec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports